"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
var React = require("react");
var ReactDOM = require("react-dom");
var common_1 = require("./common");
var utility_1 = require("../utility");
var utility_2 = require("../utility");
var ImageItem_1 = require("../../commoncomponents/src/carousel/ImageItem");
var _addToCartId = "Sale_AddToCart";
var _addToCartModalId = "pcg_shop_addtocart";
var AddToCart = /** @class */ (function (_super) {
    __extends(AddToCart, _super);
    function AddToCart(props) {
        var _this = _super.call(this, props) || this;
        _this._cart = { SelectNumber: 0, Image: "", Id: "", Price: "" };
        _this._errorMessage = { "1002": "Product does not exist", "1003": "Product does not have stock", "1004": "The entry does not exist", "1007": "Purchase quantity exceeds stock", "1008": "Purchase quantity exceeds stock", "2001": "Add to cart failed", "2002": "Error occurred while adding to Cart", "2003": "Remove entry failed" };
        _this.onHandleViewMyCart = function () {
            $("#" + _addToCartModalId).modal("hide");
            window["onHandleShowTopCart"](true);
        };
        _this.onHandleContinueShopping = function () {
            var cart = _this.state.cart;
            $("#" + _addToCartModalId).modal("hide");
            common_1.WPSShop.GoShopping(cart.CartFlag);
        };
        _this.onHandleDisplayImages = function (cart) {
            if (cart.CartFlag == utility_1.CartFlag.Parts) {
                if (cart.Image && cart.Image.length > 0) {
                    if (typeof cart.Image == "string")
                        return React.createElement("img", { src: cart.Image, alt: "product image", width: "114", height: "114", className: "pop-cell-img" });
                    var imageElements = [];
                    cart.Image.map(function (item, index) {
                        if (index == 0)
                            imageElements.push(React.createElement("a", { "data-lightbox": "AddedShop" + cart.Id, href: item },
                                " ",
                                React.createElement("span", { className: "icon-camera icon-blue" })));
                        else
                            imageElements.push(React.createElement("a", { "data-lightbox": "AddedShop" + cart.Id, href: item }));
                    });
                    return (React.createElement("div", { className: "pop-cart" }, imageElements));
                }
                else
                    return React.createElement("div", { className: "pop-cart" },
                        React.createElement("span", { className: "icon-camera" }));
            }
            else {
                if (cart.Image && cart.Image.length > 0) {
                    return (React.createElement(ImageItem_1.ImageItem, { width: "114", height: "114", image: cart.Image[0], className: "pop-cell-img", isAccessory: cart.CartFlag == utility_1.CartFlag.Accessories }));
                }
                else {
                    return (React.createElement("img", { src: "/msa/parts/images/pcg/carbon-fpo.jpg", width: 114, height: 114 }));
                }
            }
        };
        _this.onHandleAdd = function (cart, callBack) {
            if (callBack === void 0) { callBack = null; }
            _this.setState({ isLoading: true });
            common_1.WPSShop.SetCookiesForCart(cart.CartFlag, true);
            var postData = { id: cart.Id, cartFlag: cart.CartFlag, selectnumber: cart.SelectNumber || 1, sn: cart.SN, mt: cart.MT };
            utility_2.InterfaceUtility.addToCart(postData, function (response) {
                if (callBack) {
                    $("#" + _addToCartModalId).modal("hide");
                    callBack(response.code);
                    return;
                }
                if (response.code === 200) {
                    // Tracking add to cart event for the product info
                    l.DTM.updateLmd({ products: cart.Id.toString() });
                    l.DTM.satelliteTrack("eSupport-CartAdd");
                    _this.setState({ cart: cart, isLoading: false, isShowError: false });
                    window["onHandleRefreshCartData"](cart.CartFlag);
                }
                else if (response.code === 600) {
                    $("#" + _addToCartModalId).modal("hide");
                    window["onHandleShowLogin"]();
                }
                else {
                    l.DTM.Lmd.pusherrorinfTrack("Shopping added to cart error", _this._errorMessage[response.code]);
                    _this.setState({ errorMessage: response.msg, isLoading: false, isShowError: true });
                }
            }, function (response) {
                l.DTM.Lmd.pusherrorinfTrack("Shopping added to cart error", "result:" + JSON.stringify(response));
                _this.setState({ errorMessage: response, isLoading: false, isShowError: true });
            });
        };
        _this.state = {
            isLoading: true,
            isShowError: false,
            errorMessage: null,
            cart: _this._cart,
        };
        return _this;
    }
    AddToCart.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, cart = _a.cart, callBack = _a.callBack;
        this.onHandleAdd(cart, callBack);
        window["onHandleAddToCart"] = function (cart, callBack) { return _this.onHandleAdd(cart, callBack); };
    };
    AddToCart.prototype.render = function () {
        var _this = this;
        var _a = this.state, cart = _a.cart, isLoading = _a.isLoading, isShowError = _a.isShowError, errorMessage = _a.errorMessage;
        return (React.createElement("div", { id: _addToCartModalId, className: "modal fade", tabindex: "-1", role: "dialog", "aria-labelledby": "mySecondModalLabel", "aria-hidden": "true", style: { display: "none" } },
            React.createElement("div", { className: "modal-dialog caps-dialog", role: "document" },
                React.createElement("div", { className: "addToCart_popup addToCart_popup2" },
                    React.createElement("h4", null,
                        React.createElement("span", null, (function () {
                            if (isLoading)
                                return l.Translator.translate('ps please wait') + "...";
                            else {
                                if (isShowError)
                                    return l.Translator.translate('ps request error');
                                else
                                    return cart.SelectNumber + " " + l.Translator.translate('ps added success desc');
                            }
                        })()),
                        React.createElement("span", { className: "icon-l-close", onClick: function () { return $("#" + _addToCartModalId).modal('hide'); } })),
                    React.createElement("div", { className: "dialog-text" },
                        React.createElement("div", null, (function () {
                            if (isLoading) {
                                return (React.createElement("div", { style: { textAlign: "center", marginTop: "10px", marginBottom: "10px" } },
                                    React.createElement("img", { src: "/msa/parts/images/loading.gif", style: { "width": "50px", "height": "50px" } })));
                            }
                            else {
                                if (isShowError)
                                    return React.createElement("div", { style: { "fontSize": "20px", "lineHeight": "50px" } }, errorMessage);
                                else {
                                    return (React.createElement("div", { className: "pop-pro-info clearfix" },
                                        _this.onHandleDisplayImages(cart),
                                        React.createElement("div", null,
                                            React.createElement("p", { className: "pop-cell" },
                                                cart.CartFlag == utility_1.CartFlag.Parts ? l.Translator.translate('part') : l.Translator.translate('ps accessory'),
                                                ": ",
                                                cart.Id),
                                            React.createElement("p", { className: "pop-cell" },
                                                l.Translator.translate('ps price'),
                                                ": ",
                                                cart.Price)),
                                        React.createElement("button", { onClick: function () { return _this.onHandleContinueShopping(); }, title: "Continue Shopping", className: "btn-blue" }, l.Translator.translate('ps continue shopping')),
                                        React.createElement("button", { onClick: function () { return _this.onHandleViewMyCart(); }, title: l.Translator.translate('view my cart'), className: "btn-green" }, l.Translator.translate('view my cart'))));
                                }
                            }
                        })()))))));
    };
    return AddToCart;
}(React.Component));
exports.listen = function () {
    window["onHandleRenderAddToCart"] = function (cart, callBack) {
        if ($("#" + _addToCartId).length === 0) {
            $("<div></div>").attr("id", _addToCartId).appendTo("body");
            ReactDOM.render(React.createElement(AddToCart, { cart: cart, callBack: callBack }), document.getElementById(_addToCartId));
            if (!callBack)
                $("#" + _addToCartModalId).modal("show");
        }
        else {
            if (!callBack)
                $("#" + _addToCartModalId).modal("show");
            window["onHandleAddToCart"](cart, callBack);
        }
    };
};
